import React, { useState } from "react";
import toast from "react-hot-toast";
import { useCreateReservationMutation } from "../../Store/Apis/bookingApi";
import { useNavigate } from "react-router-dom";
import BarTender from "../../Components/Bar-Coordinator/BarTender";

const BarSale = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [createOrder, createOrderResponse] = useCreateReservationMutation();

  const handlePlaceOrder = async (orderData) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      console.log("Order data being sent to API:", orderData);
      const res = await createOrder(orderData);
      console.log("API Response:", res);

      if (res?.data?.status === 200) {
        toast.success(res?.data?.message, { duration: 7000 });
        navigate("/mobile-dashboard");
      } else {
        const errorMsg =
          res?.data?.message || res?.error?.data?.message || "Order failed";
        console.error("Order creation failed:", errorMsg, res);
        toast.error(errorMsg, { duration: 7000 });
      }
    } catch (err) {
      console.error("Order creation error:", err);
      const errorMsg =
        err?.data?.message || err?.message || "Something went wrong!";
      toast.error(errorMsg, { duration: 7000 });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <BarTender onSubmit={handlePlaceOrder} isSubmitting={isSubmitting} />
    </div>
  );
};

export default BarSale;
